import useSSO from '../useSSO'
import buildLoginURL from '../../utils/buildLoginURL'

function useLogin(params = {}) {
  const { loginUrl, apiKey = {}, env } = useSSO()

  const query = Object.keys(params)
    .map((key) => key + '=' + encodeURIComponent(params[key]))
    .join('&')
  const url = buildLoginURL({ loginUrl, apiKey, query, env })

  function onLoginClick() {
    if (typeof window === 'object' && url) {
      // destroy saved cart data
      /* istanbul ignore next */
      if (window.sessionStorage) {
        window.sessionStorage.removeItem('reduxPersist:billing')
        window.sessionStorage.removeItem('reduxPersist:form')
        window.sessionStorage.removeItem('reduxPersist:travelers')
      }

      window.location.assign(url)
    }
  }

  return { onLoginClick }
}

export default useLogin
